import styled from 'styled-components';
import rtl from 'styled-components-rtl';
import { toRem, theme } from '@marriott/mi-ui-library-shop';
import { baseVariables } from '@marriott/mi-ui-library';

export const StyledFindBtn = styled.button`
  ${rtl`
    position: absolute;
    top: ${toRem(18)};
    width: ${toRem(178)};
    &.border-none {
      border: none !important;
    }
    &.search-form-btn {
      line-height: ${theme.fonts['lineHeightXs']};
      height: auto !important;
      padding: ${toRem(12)} ${toRem(5)};
      min-width:${toRem(146)};
      width: auto;
      top: ${toRem(23)};
      z-index:1;
      &:focus-visible {
        outline-offset: ${toRem(2)};
      }
      &:focus:not(:focus-visible) {
        outline: none;
      }
      &:hover {
        background-color: ${theme.color['light-gray-4']};
        color:${theme.color['white']};
      }
      &.adf-update-search-btn {
        z-index:1;
        @media ${baseVariables.mediaQuery.md} {
          margin-right:${toRem(-24)};

        }
        @media ${baseVariables.mediaQuery.lg} {
          margin-right:${toRem(-40)};

        }
      }
    }
    height: ${toRem(52)} !important;
    &.search-page-btn {
      width: auto;
      padding: ${toRem(12)} ${toRem(13.1)};
      height: auto !important;
      line-height: 1;
      font-size: ${toRem(16)};
      top: ${toRem(23)};
      min-width:${toRem(146)};
      &:hover {
        background-color: var(--t-button-secondary-border-color);
      }
      &:focus {
        outline: ${toRem(2)} solid ${theme.color['black']} !important;
      }
    }
    @media ${theme.mediaQuery.tablet} {
      right: calc(50% - ${toRem(336)});
      &:focus {
        outline-offset: ${toRem(4)};
      }
    }
    @media ${theme.mediaQuery.desktop} {
      top: ${toRem(20)};
      right: calc(50% - ${toRem(448)});
      width: ${toRem(230)};
    }
    @media ${theme.mediaQuery.largeDesktop} {
      right: calc(50% - ${toRem(530)});
      width: ${toRem(275)};
    }
    &:hover {
      box-shadow: none !important;
    }

  `}
`;
